import React from "react";
import { View, StyleSheet } from "react-native";
import { useTheme } from "@/hooks/useTheme";

interface TreeNodeProps {
  children: React.ReactNode;
  depth?: number; // 0 for shifts, 1 for positions
  isLast?: boolean; // Last item in the list (affects connector styling)
  isAddButton?: boolean; // Special styling for add buttons
  gap?: number;
}

export function TreeNode({ children, depth = 0, isLast = false, gap = 0, isAddButton = false }: TreeNodeProps) {
  const { colors } = useTheme();

  const indentation = 24; // px per depth level
  const connectorWidth = 2;
  const curveRadius = 12;
  const connectorHeight = 20;

  // Both curve and vertical line at the same position for each depth level
  const linePosition = indentation * depth;
  const curveLeft = linePosition;
  const verticalLineLeft = linePosition;

  return (
    <View style={{ flexDirection: "row" }}>
      {/* Tree connector */}
      <View style={{ width: indentation * (depth + 1), position: "relative" }}>
        {/* Vertical line - starts from top to create continuous line */}
        {!isLast && (
          <View
            style={{
              position: "absolute",
              left: verticalLineLeft,
              top: 11,
              bottom: Math.abs(gap) * -1,
              width: connectorWidth,
              backgroundColor: colors.border,
              opacity: 0.4,
            }}
          />
        )}

        {/* Curved connector */}
        <View
          style={{
            position: "absolute",
            left: curveLeft,
            top: 0,
            width: indentation,
            height: connectorHeight,
            borderLeftWidth: connectorWidth,
            borderBottomWidth: connectorWidth,
            borderColor: colors.border,
            borderBottomLeftRadius: curveRadius,
            opacity: 0.4,
          }}
        />
      </View>

      {/* Content */}
      <View
        style={[
          styles.content,
          isAddButton && {
            borderStyle: "dashed",
            borderWidth: 1,
            borderColor: colors.border,
            borderRadius: 8,
            backgroundColor: colors.backgroundSecondary,
            opacity: 0.7,
          },
        ]}
      >
        {children}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
});
